import { render, staticRenderFns } from "./packages.vue?vue&type=template&id=229d502e&scoped=true"
import script from "./packages.vue?vue&type=script&lang=ts"
export * from "./packages.vue?vue&type=script&lang=ts"
import style0 from "./packages.vue?vue&type=style&index=0&id=229d502e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229d502e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/frontend_page_elephant/frontend_page_elephant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('229d502e')) {
      api.createRecord('229d502e', component.options)
    } else {
      api.reload('229d502e', component.options)
    }
    module.hot.accept("./packages.vue?vue&type=template&id=229d502e&scoped=true", function () {
      api.rerender('229d502e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warehouse/stockout/packages.vue"
export default component.exports